// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"579506e4","163":"7c861ce5","203":"33a8d371","210":"38b88b9e","365":"f235b863","607":"380f8bfc","729":"d0a1a529","950":"e4df9cf2","994":"17618334"}[chunkId] + ".chunk.js";
};